<template>
  <div>
    <FormWizardStepHeader
      title="Brilliant basics"
      description="Get the basics right and you are off to a better start"
    />

    <FormItem
      label="Type of investor"
      invalid-message="Please select your type"
      :state="$v.category.$dirty ? !$v.category.$error : null"
      required
    >
      <b-form-select
        v-model="form.category"
        class="form-select-item"
        :options="categoryOptions"
      ></b-form-select>
    </FormItem>

    <FormItem
      label="Website or LinkedIn"
      invalid-message="Please enter website address or LinkedIn"
      :state="$v.website.$dirty ? !$v.website.$error : null"
      required
    >
      <b-form-input
        v-model="form.website"
        :state="$v.website.$dirty ? !$v.website.$error : null"
        placeholder="https://"
        @blur="$v.website.$touch()"
      />
    </FormItem>

    <FormItem
      :label="
        'Select the investment tickets that you support, you can select multiple' +
          (form.category === 'ACCELERATORS' ? ' (optional)' : '')
      "
      invalid-message="Please select the investment tickets"
      :state="$v.investmentRanges.$dirty ? !$v.investmentRanges.$error : null"
      :required="form.category !== 'ACCELERATORS'"
    >
      <b-form-checkbox-group
        v-model="form.investmentRanges"
        buttons
        class="btn-group-outline-spaced"
        @input="$v.investmentRanges.$touch()"
      >
        <b-form-checkbox
          v-for="item in investmentRanges"
          :key="item.value"
          :value="item.value"
          >{{ item.label }}</b-form-checkbox
        >
      </b-form-checkbox-group>
    </FormItem>
  </div>
</template>

<script>
import FormWizardStepHeader from '@/components/FormWizardStepHeader'
import FormItem from '@/components/form/FormItem'

export default {
  name: 'InvestorFormStepBasics',
  components: {
    FormWizardStepHeader,
    FormItem
  },
  props: {
    $v: {
      type: Object,
      required: true
    },
    value: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        ...this.value,
        category: this.value.category ? this.value.category : null
      }
    }
  },
  computed: {
    categoryOptions() {
      return [
        {
          value: null,
          text: 'Select type',
          disabled: true
        }
      ].concat(
        this.$store.getters['meta/investorCategories'].map((item) => ({
          value: item.value,
          text: item.label
        }))
      )
    },
    investmentRanges() {
      return this.$store.getters['meta/investorInvestmentRanges']
    }
  },
  watch: {
    value(newValue) {
      this.form = newValue
    },
    form: {
      deep: true,
      handler() {
        this.$emit('input', this.form)
      }
    }
  }
}
</script>
